/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type CardAccountWithdrawResponseIntent = typeof CardAccountWithdrawResponseIntent[keyof typeof CardAccountWithdrawResponseIntent];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CardAccountWithdrawResponseIntent = {
  charge: 'charge',
  refund: 'refund',
  topup: 'topup',
  withdraw: 'withdraw',
  repay: 'repay',
  cashback: 'cashback',
  interest: 'interest',
  transfer: 'transfer',
  fee: 'fee',
  other: 'other',
} as const;
